import { render } from "./AuctionList.vue?vue&type=template&id=51c172e6&scoped=true&ts=true"
import script from "./AuctionList.vue?vue&type=script&lang=ts"
export * from "./AuctionList.vue?vue&type=script&lang=ts"

import "./AuctionList.vue?vue&type=style&index=0&id=51c172e6&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c172e6"]])

export default __exports__